/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import background from '../../assets/images/not_found_page_bg.svg';

const createNotFoundLayoutStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      width: '100vw',
      height: '100vh',
      backgroundImage: `url('${background}')`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundColor: '#1D3B67',
      position: 'relative',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
  }),
);

export { createNotFoundLayoutStyles };
